<template>
    <BaseInputCheckbox v-model="inputActivated" novalidate :name="'temp.' + props.name + '_checkbox'">
        <span class="mb-1 block px-2 text-sm font-medium text-gray-700">{{ label }}</span>
        <BaseInputText
            v-model="data"
            :disabled="!inputActivated"
            :name="props.name"
            class="px-2 py-1"
            label=""></BaseInputText>
    </BaseInputCheckbox>
</template>

<script setup lang="ts">
import BaseInputCheckbox from './BaseInputCheckbox.vue'
import BaseInputText from './BaseInputText.vue'
import { onMounted, ref, watch } from 'vue'

onMounted(() => {
    inputActivated.value = props.modelValue !== '' && props.modelValue !== null
})
const inputActivated = ref(false)

watch(inputActivated, (newValue) => {
    if (!newValue) {
        data.value = ''
    }
})

import { useVModel } from '@vueuse/core'

const props = defineProps<{
    modelValue: string
    name: string
    label: string
}>()
const emit = defineEmits(['update:modelValue'])

const data = useVModel(props, 'modelValue', emit)
</script>
